export const USER_SIGNUP_SUCCESS="USER_SIGNUP_SUCCESS"
export const USER_SIGIN_SUCCESS="USER_SIGIN_SUCCESS"
export const LOAD_TIPOGRAM_CONTRACT="LOAD_TIPOGRAM_CONTRACT"
export const FETCH_OWNER_ACCOUNT="FETCH_OWNER_ACCOUNT"
export const GET_USER_PROFILE="GET_USER_PROFILE"
export const UPLOAD_IMAGE="UPLOAD_IMAGE"
export const FETCH_TIPOGRAM_IMAGES="FETCH_TIPOGRAM_IMAGES"
export const UPDATE_POSTS_LIKES="UPDATE_POSTS_LIKES"
export const UPDATE_AUTHOR_LIKES="UPDATE_AUTHOR_LIKES"
export const GET_ALL_USERS="GET_ALL_USERS"
export const UPDATE_BADGES="UPDATE_BADGES"
export const UPDATE_USER_PROFILE="UPDATE_USER_PROFILE"